<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex';

const store = useStore()
const loading = computed(() => store.state.globals.loading);
const props = defineProps({
    nov: {
        type: [Object, null],
        required: true
    }
});

</script>

<template>
    <b-overlay :show="loading">
      <div class="p-1">
        <div v-if="props.nov['0'].generated_pdf_file_link" class="card-body overflow-auto">
          <div v-for="(entry, index) in props.nov" :key="index">
            <iframe  :src="entry.generated_pdf_file_link" height="800px" width="100%"></iframe>
          </div>
        </div>
        <div class="p-2" v-else>
          <h5>Notice of Violation (NOV) for this file # is not available!</h5>
        </div>
      </div>
    </b-overlay>
</template>
